import { supabase } from '../utils/supabaseClient';

/**
 * Create a new resource
 */
export const createResource = async (resourceData) => {
  try {
    const { data, error } = await supabase
      .from('resources')
      .insert([resourceData])
      .select()
      .single();

    if (error) throw error;

    return { success: true, data };
  } catch (error) {
    console.error('Error creating resource:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Get all public resources
 */
export const getPublicResources = async () => {
  try {
    const { data, error } = await supabase
      .from('resources')
      .select('*')
      .eq('is_public', true)
      .order('created_at', { ascending: false });

    if (error) throw error;

    return { success: true, data };
  } catch (error) {
    console.error('Error fetching resources:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Get a single resource by ID
 */
export const getResourceById = async (id) => {
  try {
    const { data, error } = await supabase
      .from('resources')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;

    return { success: true, data };
  } catch (error) {
    console.error('Error fetching resource:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Update an existing resource
 */
export const updateResource = async (id, resourceData) => {
  try {
    const { data, error } = await supabase
      .from('resources')
      .update(resourceData)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;

    return { success: true, data };
  } catch (error) {
    console.error('Error updating resource:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Delete a resource
 */
export const deleteResource = async (id) => {
  try {
    const { error } = await supabase
      .from('resources')
      .delete()
      .eq('id', id);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error('Error deleting resource:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Get resources by category
 */
export const getResourcesByCategory = async (category) => {
  try {
    const { data, error } = await supabase
      .from('resources')
      .select('*')
      .eq('is_public', true)
      .eq('category', category)
      .order('created_at', { ascending: false });

    if (error) throw error;

    return { success: true, data };
  } catch (error) {
    console.error('Error fetching resources by category:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Get featured resources
 */
export const getFeaturedResources = async () => {
  try {
    const { data, error } = await supabase
      .from('resources')
      .select('*')
      .eq('is_public', true)
      .eq('featured', true)
      .order('created_at', { ascending: false });

    if (error) throw error;

    return { success: true, data };
  } catch (error) {
    console.error('Error fetching featured resources:', error);
    return { success: false, error: error.message };
  }
};
